import { render, staticRenderFns } from "./Step2HotelBooking.vue?vue&type=template&id=b50f46d0&scoped=true&"
import script from "./Step2HotelBooking.vue?vue&type=script&lang=js&"
export * from "./Step2HotelBooking.vue?vue&type=script&lang=js&"
import style0 from "./Step2HotelBooking.vue?vue&type=style&index=0&id=b50f46d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50f46d0",
  null
  
)

export default component.exports